import { render, staticRenderFns } from "./CreateFareGroupBtn.vue?vue&type=template&id=326ab87e&"
import script from "./CreateFareGroupBtn.vue?vue&type=script&lang=js&"
export * from "./CreateFareGroupBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports